import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class CheckCGV extends HTMLDivElement {
    constructor() {
        super();

        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.initEvents();
    }

    getSelectorCheckboxCGV () {
        return '#accept_cgv';
    }

    toggleValidationCGV( elementItem, container ) {
        var requestor = new Requestor();

        requestor.sendRequest( elementItem.dataset.route,'PUT', {
            'update-cart'       : true,
            'accept_cgv'        : elementItem.checked ? 1 : 0,
            'return_templates'  : ['transformation.transformation-prices'],
        },  (data) => {
            container.updateCartIndexView(data);
        })
    }

    initEvents() {
        this.querySelector(this.getSelectorCheckboxCGV()).addEventListener('change',  (e) => {
            e.preventDefault();

            this.toggleValidationCGV(e.target, this.mainContainer);
        });
    }
};

